'use client'

import React, { useState } from 'react'
import ReactPaginate from 'react-paginate'
import PaginationCard from '@/components/Cards/PaginationCard'
import { useNews } from '@/hooks/useNews'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { AdsArticles } from '@/components/Common'

const AdvertisementSection = () => {
  const [currentPage, setCurrentPage] = useState(1)
  // Hook useNews với page được chọn
  const {
    allNews,
    totalPages,
    isLoading: isNewsLoading,
    isError,
  } = useNews({
    page: currentPage,
    size: 10,
  })

  // Hàm xử lý khi chuyển trang
  const handlePageChange = (selectedItem: { selected: number }) => {
    setCurrentPage(selectedItem.selected + 1) // react-paginate sử dụng 0-based index
  }

  return (
    <section className="container my-4">
      <div className="grid grid-cols-12 gap-4">
        {/* Cột bên phải */}
        <div className="col-span-12 md:col-span-9 ">
          {/* Hiển thị bài viết */}
          {isNewsLoading
            ? Array.from({ length: 10 }).map((_, index) => <PaginationCard key={index} isLoading />)
            : allNews.map((item) => (
                <PaginationCard
                  key={item.id}
                  imageUrl={item.imageUrl}
                  title={item.title}
                  description={item.description}
                  publishDate={item.publishDate}
                  categoryName={item.categoryName}
                  link={item.slug}
                />
              ))}

          {/* Phân trang */}
          {/* Phân trang */}
          <div className="flex justify-center gap-2 mt-4">
            <nav role="navigation" aria-label="Pagination">
              <ReactPaginate
                pageCount={totalPages}
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                onPageChange={handlePageChange}
                forcePage={currentPage - 1}
                previousLabel={<FontAwesomeIcon icon={faAngleLeft} />}
                nextLabel={<FontAwesomeIcon icon={faAngleRight} />}
                breakLabel="..."
                containerClassName="pagination flex gap-2 list-none"
                pageClassName="page-item"
                pageLinkClassName="block px-4 py-2 rounded-md bg-gray-300 text-gray-700 hover:bg-gray-400"
                activeClassName="active"
                activeLinkClassName="bg-primary text-white font-bold"
                previousClassName="page-item"
                previousLinkClassName="block px-4 py-2 rounded-md bg-primary text-white"
                nextClassName="page-item"
                nextLinkClassName="block px-4 py-2 rounded-md bg-primary text-white"
                disabledClassName="opacity-50 cursor-not-allowed"
                breakClassName="page-item"
                breakLinkClassName="text-gray-500"
                renderOnZeroPageCount={null}
              />
            </nav>
          </div>

          {/* Hiển thị khi có lỗi */}
          {isError && <p className="mt-4 text-red-500">Có lỗi xảy ra!</p>}
        </div>
        {/* Cột bên trái */}
        <div className="col-span-12  md:col-span-3">
          <AdsArticles />
        </div>
      </div>
    </section>
  )
}

export default AdvertisementSection
